import { sendTrackingEvent } from 'tracking/utils/sendTrackingEvent';

export const handleSectionClick = (moduleTrackingData = {}) => {
  sendTrackingEvent('CMS_MODULE_TAP', { ...moduleTrackingData });
};
